<script>
  import { dataset_dev } from "svelte/internal";
  import {
    preguntas,
    eliminarDocumentosDeColeccion,
    updateDoc,
  } from "../../stores/CES";
  import { navigate } from "svelte-routing";
  import { onMount } from "svelte";
  import { userRol } from "../../stores/user";
  import {
    dataEdit,
    viewsData,
    updateD,
    panelController,
    updateService,
  } from "../../stores/service";
  /* let ord = []
  function orden (numero){
    orden[numero]=numero;
  } */
  document.title = "Ratingg | Ordenar";
  let dataList = [];


 

  function controlData(o, i) {
    let temp = dataList[i];
    switch (o) {
      case 1:
        dataList[i] = dataList[i - 1];
        dataList[i - 1] = temp;

        break;
      case 2:
        dataList[i] = dataList[i + 1];
        dataList[i + 1] = temp;
        break;

      default:
        break;
    }
  }

  function control(o) {
    $panelController.viewOrdenar.nav = false;
    switch (o) {
      case 1:
        $panelController.service.listRatinggs[
          $panelController.viewOrdenar.index[0]
        ].rattings = dataList;

        updateService();

        navigate("/panel", { replace: true });
        break;
      case 2:
      navigate("/panel", { replace: true });
        break;

      default:
        break;
    }
    navigate("/panel", { replace: true });
  }

  function update(array, fromIndex, toIndex) {
    const newArray = [...array];
    const [movedItem] = newArray.splice(fromIndex, 1);
    newArray.splice(toIndex, 0, movedItem);

    return newArray;
  }
  onMount(async () => {
    if (!$panelController.viewOrdenar.status) {
      navigate("/service", { replace: true });
    }
    /* {$panelController.service.listRatinggs[$panelController.viewOrdenar.index[0]].config.name} */

    dataList =
      $panelController.service.listRatinggs[
        $panelController.viewOrdenar.index[0]
      ].rattings;
  });
</script>

<div class="card text-center">
  <div class="card-header">
    {$panelController.service.listRatinggs[
      $panelController.viewOrdenar.index[0]
    ].config.name}
  </div>
  <div class="card-body">
    <div class="row">
      <div class="form-group col-1">
        <label for="numero1">N.</label>
      </div>
      <div class="form-group col-4">
        <label for="numero1">Pregunta</label>
      </div>
      <div class="form-group col-3">
        <label for="numero2">Tipo</label>
      </div>
      <div class="form-group col-2">
        <label for="numero2">Subir</label>
      </div>
      <div class="form-group col-2">
        <label for="numero2">Bajar</label>
      </div>
    </div>
    {#each dataList as item, index}
      <div class="row">
        <div class="form-group col-1">
          <p>{index + 1}</p>
        </div>

        <div class="form-group col-4">
          <p>{item.pregunta}</p>
        </div>

        <div class="form-group col-3">
          {#if item.tipo == 1}
            <p>Multiple</p>
          {/if}
          {#if item.tipo == 2}
            <p>Botonera</p>
          {/if}
          {#if item.tipo == 3}
            <p>Rango</p>
          {/if}
          {#if item.tipo == 4}
            <p>Normal</p>
          {/if}
        </div>
        {#if index !== 0}
          <div class="form-group col-2">
            <button
              type="button"
              class="btn btn-outline-secondary"
              on:click={() => {
                controlData(1, index);
              }}
            >
            <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-chevron-compact-up"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M7.776 5.553a.5.5 0 0 1 .448 0l6 3a.5.5 0 1 1-.448.894L8 6.56 2.224 9.447a.5.5 0 1 1-.448-.894z"
            ></path>
          </svg>
          <span class="visually-hidden"
            ><font style="vertical-align: inherit;"
              ><font style="vertical-align: inherit;">Botón</font></font
            ></span
          >
              <span class="visually-hidden"
                ><font style="vertical-align: inherit;"
                  ><font style="vertical-align: inherit;">Botón</font></font
                ></span
              >
            </button>
          </div>
        {:else}
          <div class="form-group col-2"></div>
        {/if}
        {#if index < dataList.length - 1}
          <div class="form-group col-2">
            <button
              type="button"
              class="btn btn-outline-secondary"
              on:click={() => {
                controlData(2, index);
              }}
            >

            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-chevron-compact-down"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67"
                ></path>
              </svg>
              
            </button>
          </div>
        {:else}
          <div class="form-group col-2"></div>
        {/if}
      </div>
    {/each}
  </div>
  <div class="card-footer text-body-secondary m-1">
    <button
      type="button"
      class="btn btn-outline-primary m-1"
      on:click={() => {
        control(1);
      }}>Guardar
      <i class="bi bi-check2-circle"></i>
      </button
    ><button
      type="button"
      class="btn btn-outline-danger m-1"
      on:click={() => {
        control(2);
      }}>Cancelar
      <i class="bi bi-x-circle"></i>
      </button
    >
  </div>
</div>



<style>
  table {
    border-collapse: collapse;
    width: 100%;
  }

  th,
  td {
    border: 1px solid black;
    padding: 8px;
    text-align: left;
  }
</style>
